import axios from 'axios';
import { domain, basicAuth } from '../config/auth';
import eventEmitter from './EventEmitter';

// Create an axios instance
const axiosInstance = axios.create({
    baseURL: domain, // API base URL
    timeout: 10000, // Optional timeout configuration
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        if (typeof window !== 'undefined') { 
            const token = localStorage.getItem('accessToken') || localStorage.getItem('temporaryToken') || '';
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }else {
                config.headers.Authorization = `Basic ${basicAuth}`;
            }
        }
        eventEmitter.emit('loader:start');
        return config;
    },
    (error) => {
        eventEmitter.emit('loader:stop');
        return Promise.reject(new Error(error));
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        eventEmitter.emit('loader:stop');
        return response;
    },
    (error) => {
        eventEmitter.emit('loader:stop');
        if (error.response && error.response.status === 401) {
            // Handle unauthorized error
            if (typeof window !== 'undefined') {
                // Clear tokens from localStorage
                localStorage.removeItem('accessToken');
                localStorage.removeItem('temporaryToken');

                // Redirect to the login page (or wherever appropriate)
                window.location.href = '/login'; // Adjust this path as needed
            }
        }
        return Promise.reject(new Error(error));
    }
);

export default axiosInstance;